const replaceTag = (tag: string): string => {
  const tagsToReplace: any = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '/': '&#x2F;',
  };
  return tagsToReplace[tag] || tag;
};

export default (str: string): string => str.replace(/[&<>]/g, replaceTag);
